// src/enums/index.ts
var UserRole = /* @__PURE__ */ ((UserRole2) => {
  UserRole2["ADMIN"] = "ADMIN";
  UserRole2["OPERATOR"] = "OPERATOR";
  UserRole2["VIEWER"] = "VIEWER";
  return UserRole2;
})(UserRole || {});
var ServiceStatus = /* @__PURE__ */ ((ServiceStatus2) => {
  ServiceStatus2["STOPPED"] = "STOPPED";
  ServiceStatus2["STARTING"] = "STARTING";
  ServiceStatus2["RUNNING"] = "RUNNING";
  ServiceStatus2["STOPPING"] = "STOPPING";
  ServiceStatus2["ERROR"] = "ERROR";
  ServiceStatus2["WAITING_SOURCE"] = "WAITING_SOURCE";
  ServiceStatus2["WAITING_DESTINATION"] = "WAITING_DESTINATION";
  return ServiceStatus2;
})(ServiceStatus || {});
var HardwareAccelType = /* @__PURE__ */ ((HardwareAccelType2) => {
  HardwareAccelType2["NONE"] = "NONE";
  HardwareAccelType2["NVENC"] = "NVENC";
  HardwareAccelType2["QSV"] = "QSV";
  HardwareAccelType2["VAAPI"] = "VAAPI";
  HardwareAccelType2["VIDEOTOOLBOX"] = "VIDEOTOOLBOX";
  return HardwareAccelType2;
})(HardwareAccelType || {});
var CaptureProtocol = /* @__PURE__ */ ((CaptureProtocol2) => {
  CaptureProtocol2["AUTO"] = "AUTO";
  CaptureProtocol2["RTMP"] = "RTMP";
  CaptureProtocol2["SRT"] = "SRT";
  CaptureProtocol2["HLS"] = "HLS";
  return CaptureProtocol2;
})(CaptureProtocol || {});
var SrtOutputDialect = /* @__PURE__ */ ((SrtOutputDialect2) => {
  SrtOutputDialect2["WOWZA"] = "WOWZA";
  SrtOutputDialect2["OME"] = "OME";
  return SrtOutputDialect2;
})(SrtOutputDialect || {});
var EncodingProfile = /* @__PURE__ */ ((EncodingProfile2) => {
  EncodingProfile2["STANDARD"] = "STANDARD";
  EncodingProfile2["WEBRTC"] = "WEBRTC";
  return EncodingProfile2;
})(EncodingProfile || {});
var FFmpegPreset = /* @__PURE__ */ ((FFmpegPreset2) => {
  FFmpegPreset2["ULTRAFAST"] = "ULTRAFAST";
  FFmpegPreset2["SUPERFAST"] = "SUPERFAST";
  FFmpegPreset2["VERYFAST"] = "VERYFAST";
  FFmpegPreset2["FASTER"] = "FASTER";
  FFmpegPreset2["FAST"] = "FAST";
  FFmpegPreset2["MEDIUM"] = "MEDIUM";
  FFmpegPreset2["SLOW"] = "SLOW";
  FFmpegPreset2["SLOWER"] = "SLOWER";
  FFmpegPreset2["VERYSLOW"] = "VERYSLOW";
  return FFmpegPreset2;
})(FFmpegPreset || {});
var VideoProfile = /* @__PURE__ */ ((VideoProfile2) => {
  VideoProfile2["BASELINE"] = "BASELINE";
  VideoProfile2["MAIN"] = "MAIN";
  VideoProfile2["HIGH"] = "HIGH";
  VideoProfile2["HIGH10"] = "HIGH10";
  return VideoProfile2;
})(VideoProfile || {});
var ResolutionPreset = /* @__PURE__ */ ((ResolutionPreset2) => {
  ResolutionPreset2["PASSTHROUGH"] = "passthrough";
  ResolutionPreset2["RES_1080P"] = "1080p";
  ResolutionPreset2["RES_720P"] = "720p";
  ResolutionPreset2["RES_480P"] = "480p";
  ResolutionPreset2["RES_360P"] = "360p";
  ResolutionPreset2["RES_240P"] = "240p";
  ResolutionPreset2["RES_144P"] = "144p";
  return ResolutionPreset2;
})(ResolutionPreset || {});
var RESOLUTION_CONFIG = {
  ["passthrough" /* PASSTHROUGH */]: {
    height: 0,
    width: 0,
    recommendedBitrate: 0,
    label: "Passthrough (Sin transcodificaci\xF3n)",
    level: ""
  },
  ["1080p" /* RES_1080P */]: {
    height: 1080,
    width: 1920,
    recommendedBitrate: 4500,
    label: "1080p (Full HD)",
    level: "4.1"
  },
  ["720p" /* RES_720P */]: {
    height: 720,
    width: 1280,
    recommendedBitrate: 2500,
    label: "720p (HD)",
    level: "3.1"
  },
  ["480p" /* RES_480P */]: {
    height: 480,
    width: 854,
    recommendedBitrate: 1500,
    label: "480p (SD)",
    level: "3.0"
  },
  ["360p" /* RES_360P */]: {
    height: 360,
    width: 640,
    recommendedBitrate: 800,
    label: "360p",
    level: "3.0"
  },
  ["240p" /* RES_240P */]: {
    height: 240,
    width: 426,
    recommendedBitrate: 400,
    label: "240p",
    level: "2.1"
  },
  ["144p" /* RES_144P */]: {
    height: 144,
    width: 256,
    recommendedBitrate: 200,
    label: "144p",
    level: "1.3"
  }
};
function getResolutionPresetFromHeight(height) {
  if (height >= 1080) return "1080p" /* RES_1080P */;
  if (height >= 720) return "720p" /* RES_720P */;
  if (height >= 480) return "480p" /* RES_480P */;
  if (height >= 360) return "360p" /* RES_360P */;
  if (height >= 240) return "240p" /* RES_240P */;
  if (height >= 144) return "144p" /* RES_144P */;
  return null;
}
function getAvailablePresetsForSource(sourceHeight) {
  const allPresets = Object.values(ResolutionPreset);
  return allPresets.filter((preset) => {
    if (preset === "passthrough" /* PASSTHROUGH */) return true;
    return RESOLUTION_CONFIG[preset].height <= sourceHeight;
  });
}
function isPassthroughPreset(resolution) {
  return resolution === "passthrough" /* PASSTHROUGH */;
}
var ProcessStatus = /* @__PURE__ */ ((ProcessStatus2) => {
  ProcessStatus2["PENDING"] = "PENDING";
  ProcessStatus2["RUNNING"] = "RUNNING";
  ProcessStatus2["COMPLETED"] = "COMPLETED";
  ProcessStatus2["FAILED"] = "FAILED";
  ProcessStatus2["CANCELLED"] = "CANCELLED";
  return ProcessStatus2;
})(ProcessStatus || {});
var LogLevel = /* @__PURE__ */ ((LogLevel2) => {
  LogLevel2["DEBUG"] = "DEBUG";
  LogLevel2["INFO"] = "INFO";
  LogLevel2["WARN"] = "WARN";
  LogLevel2["ERROR"] = "ERROR";
  return LogLevel2;
})(LogLevel || {});
var AuditAction = /* @__PURE__ */ ((AuditAction2) => {
  AuditAction2["CREATE"] = "CREATE";
  AuditAction2["UPDATE"] = "UPDATE";
  AuditAction2["DELETE"] = "DELETE";
  AuditAction2["LOGIN"] = "LOGIN";
  AuditAction2["LOGOUT"] = "LOGOUT";
  AuditAction2["START_SERVICE"] = "START_SERVICE";
  AuditAction2["STOP_SERVICE"] = "STOP_SERVICE";
  return AuditAction2;
})(AuditAction || {});

// src/api/index.ts
var HttpStatus = /* @__PURE__ */ ((HttpStatus2) => {
  HttpStatus2[HttpStatus2["OK"] = 200] = "OK";
  HttpStatus2[HttpStatus2["CREATED"] = 201] = "CREATED";
  HttpStatus2[HttpStatus2["NO_CONTENT"] = 204] = "NO_CONTENT";
  HttpStatus2[HttpStatus2["BAD_REQUEST"] = 400] = "BAD_REQUEST";
  HttpStatus2[HttpStatus2["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
  HttpStatus2[HttpStatus2["FORBIDDEN"] = 403] = "FORBIDDEN";
  HttpStatus2[HttpStatus2["NOT_FOUND"] = 404] = "NOT_FOUND";
  HttpStatus2[HttpStatus2["CONFLICT"] = 409] = "CONFLICT";
  HttpStatus2[HttpStatus2["UNPROCESSABLE_ENTITY"] = 422] = "UNPROCESSABLE_ENTITY";
  HttpStatus2[HttpStatus2["TOO_MANY_REQUESTS"] = 429] = "TOO_MANY_REQUESTS";
  HttpStatus2[HttpStatus2["INTERNAL_SERVER_ERROR"] = 500] = "INTERNAL_SERVER_ERROR";
  HttpStatus2[HttpStatus2["SERVICE_UNAVAILABLE"] = 503] = "SERVICE_UNAVAILABLE";
  return HttpStatus2;
})(HttpStatus || {});
export {
  AuditAction,
  CaptureProtocol,
  EncodingProfile,
  FFmpegPreset,
  HardwareAccelType,
  HttpStatus,
  LogLevel,
  ProcessStatus,
  RESOLUTION_CONFIG,
  ResolutionPreset,
  ServiceStatus,
  SrtOutputDialect,
  UserRole,
  VideoProfile,
  getAvailablePresetsForSource,
  getResolutionPresetFromHeight,
  isPassthroughPreset
};
